// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `v-person-search-dropdown .mask {
  position: fixed;
  pointer-events: fill;
  z-index: 100;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
v-person-search-dropdown .search-bar {
  position: relative;
  z-index: 101;
}

.person-search-dropdown-close {
  position: absolute;
  right: 0px;
  top: 5px;
}

.person-search-overlay {
  min-width: 40vw;
  min-height: 35vh;
  height: 100%;
  max-height: 45vh;
  display: grid;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-person-search/dropdown/v-person-search-dropdown.component.sass"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,oBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAAR;AAEI;EACI,kBAAA;EACA,YAAA;AAAR;;AAEA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AACJ;;AACA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAEJ","sourcesContent":["v-person-search-dropdown\n    .mask\n        position:  fixed\n        pointer-events: fill\n        z-index: 100\n        top: 0\n        left: 0\n        bottom: 0\n        right: 0\n\n    .search-bar\n        position: relative\n        z-index: 101\n\n.person-search-dropdown-close\n    position: absolute\n    right: 0px\n    top: 5px\n\n.person-search-overlay\n    min-width: 40vw\n    min-height: 35vh\n    height: 100%\n    max-height: 45vh\n    display: grid"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
